import { REPORT } from '@consts/reports';

// todo: Split up into own enums
export const API: { [key: string]: string } = {
    // Dashboard URLs
    [REPORT.DASHBOARD_TIPS]: '/dashboard/dashboardTips',
    [REPORT.TOTAL_SUCCESSFUL_CUTS_BY_MONTH]: '/dashboard/totalSuccessfulCutsByMonth',
    [REPORT.TOTAL_SUCCESSFUL_CUTS_BY_LOCATION_THIS_MONTH]: '/dashboard/totalSuccessfulCutsByLocationThisMonth',
    [REPORT.TOTAL_SUCCESSFUL_CUTS_BY_LOCATION_LAST_MONTH]: '/dashboard/totalSuccessfulCutsByLocationLastMonth',
    [REPORT.WARRANTY_RATE_BY_MONTH_COMPARED_TO_GLOBAL_AVERAGE]: '/dashboard/warrantyRateByMonthComparedToGlobalAverage',
    [REPORT.MANUFACTURER_BREAKDOWN]: '/dashboard/manufacturerBreakdown',
    [REPORT.MO_GLOBAL_PRESENCE]: '/dashboard/globalPresence',
    [REPORT.AVERAGE_CUTS_PER_LOCATION_PER_COUNTRY_PER_MONTH_COMPARED_TO_REGION_AVERAGE]:
        '/dashboard/averageCutsPerLocationPerCountryPerMonthComparedToRegionAverage',

    // Resellers URLs
    [REPORT.RESELLER_TIPS]: '/resellers/resellerTips',
    [REPORT.RESELLER_SUCCESSFUL_CUTS_BY_RESELLER_LAST_MONTH]: '/resellers/successfulCutsByResellerMonth',
    [REPORT.RESELLER_SUCCESSFUL_CUTS_BY_RESELLER_THIS_MONTH]: '/resellers/successfulCutsByResellerMonth',
    [REPORT.RESELLER_SUCCESSFUL_CUTS_BY_RESELLER_FOR_DATE_RANGE]: '/resellers/successfulCutsbyResellerForDateRange',
    [REPORT.RESELLER_AVERAGE_CUTS_PER_LOCATION_PER_RESELLER]:
        '/resellers/averageCutsPerLocationPerResellerVsRegionVsGlobal',
    [REPORT.RESELLER_FULL_BODY_PERCENTAGE_RATE_PER_RESELLER]: '/resellers/fullBodyRatePerResellerComparedToGlobal',
    [REPORT.RESELLER_WARRANTY_RATE_BY_RESELLER_COMPARED_TO_GLOBAL_AVERAGE]:
        '/resellers/warrantyRateByResellerComparedToGlobal',
    [REPORT.RESELLER_CUT_VOLUME_GROWTH_BY_RESELLER]: '/resellers/cutVolumeGrowthByReseller',
    [REPORT.RESELLER_MATERIAL_TYPE_CUTS_BY_RESELLER]: '/resellers/materialCutsByReseller',
    [REPORT.RESELLER_MATERIAL_TYPE_PERFORMANCE_AS_A_PERCENTAGE_BY_RESELLER]:
        '/resellers/materialTypePerformanceByReseller',
    [REPORT.RESELLER_NUMBER_OF_ACTIVE_LOCATIONS_BY_RESELLER]: '/resellers/activeLocationsByReseller',

    // Locations
    [REPORT.LOCATION_TIPS]: '/locations/locationTips',
    [REPORT.LOCATION_TOTAL_SUCCESSFUL_CUTS_BY_LOCATION_THIS_MONTH]: '/locations/totalSuccessfulCutsByLocationThisMonth',
    [REPORT.LOCATION_TOTAL_SUCCESSFUL_CUTS_BY_LOCATION_LAST_MONTH]: '/locations/totalSuccessfulCutsByLocationLastMonth',
    [REPORT.LOCATION_TOTAL_SUCCESSFUL_CUTS_BY_LOCATION_FOR_DATE_RANGE]:
        '/locations/successfulCutsbyLocationForDateRange',
    [REPORT.LOCATION_FULL_BODY_RATE_PER_LOCATION]: '/locations/fullBodyRatePctPerLocationVsGlobal',
    [REPORT.LOCATION_WARRANTY_RATE_BY_LOCATION]: '/locations/warrantyRateByLocationVsGlobal',
    [REPORT.LOCATION_MONTHLY_CUT_VOLUME_GROWTH_BY_LOCATION]: '/locations/cutVolumeGrowthByLocation',
    [REPORT.LOCATION_MATERIAL_TYPE_CUTS_BY_LOCATION]: '/locations/materialCutsByLocation',
    [REPORT.LOCATION_PERCENTAGE_PRODUCT_REGISTRATIONS_PER_COUNTRY]: '/locations/pctProductRegByCountry',
    [REPORT.LOCATION_PERCENTAGE_PRODUCT_REGISTRATIONS_PER_LOCATION]: '/locations/pctProductRegByLocation',

    // Products
    [REPORT.PRODUCTS_TIPS]: '/products/productTips',
    [REPORT.PRODUCTS_OVERALL_FULL_BODY_RATE]: '/products/fullBodyRatePctVsGlobal',
    [REPORT.PRODUCTS_OVERALL_TOTAL_WARRANTY_RATE_BY_MONTH_BY_MATERIAL]: '/products/totalWarrantyByMonthByMaterial',
    [REPORT.PRODUCTS_OVERALL_MATERIAL_TYPE_CUT_PERCENTAGE]: '/products/materialTypesVsGlobal',
    [REPORT.PRODUCTS_OVERALL_MATERIAL_TYPE_CUT_PERCENTAGE_OVER_TIME]: '/products/materialPctOverTimeVsGlobal',
    [REPORT.PRODUCTS_SUCCESSFUL_CUTS_BY_COVERAGE_TYPE]: '/products/successfulCutsByCoverageType',
    [REPORT.PRODUCTS_SUCCESSFUL_CUT_VOLUME_BY_MODEL]: '/products/cutVolumeByModel',
    [REPORT.PRODUCTS_LOCATION_GLOBAL_RANK_OF_MATERIAL]: '/products/locationGlobalRankMaterial',

    // Issues
    [REPORT.ISSUES_TIPS]: '/issues/issueTips',
    [REPORT.ISSUES_LOCATIONS_CUT_LAST_MONTH]: '/issues/locationsThisNotLast',
    [REPORT.ISSUES_RESELLERS_CUT_LAST_MONTH]: '/issues/resellersThisNotLast',
    [REPORT.ISSUES_LOCATIONS_HAVE_NOT_CUT_IN_PAST_SEVEN_DAYS]: '/issues/noCutsIn7',
    [REPORT.ISSUES_LOCATIONS_WITH_OVER_FIFTY_PERCENTAGE_WARRANTY_RATE]: '/issues/locationsOverWarrantyThreshold',
    [REPORT.ISSUES_LOCATIONS_HAVE_NOT_CUT]: '/issues/locationNotCutMaterial',

    GET_ALL_COMPANIES: '/org/companies',
    GET_ALL_RESELLERS: '/org/resellers',
    GET_ALL_LOCATIONS: '/org/locations',

    // Sign in
    SIGN_IN: '/signIn',
    REFRESH_TOKEN: '/refreshToken',

    // Forget Password
    REQUEST_PASSWORD_RESET: '/requestPassReset',
    CONFIRM_PASSWORD_RESET: '/confirmPassReset',
};

export const REGISTER_URL =
    'https://docs.google.com/forms/d/e/1FAIpQLSfZIaMhUYbZEnhi5n8e_AXWF1HYJL1L4Lho2J2Rds3QgFkbwg/viewform';
